import GeneralTemplate from '../templates/GeneralTemplate';
import cover from '../assets/cover/homepage.webp';
import ScenarioBanner from '../components/ScenarioBanner'
import ServiceIntro from '../components/ServiceIntro'
import Button from '../layout/Button'; 

function Home() {
  const bannerProps = {
    imageSrc: cover,
    height: "100vh",
    title: "找找公車",
    titeSize:"70",
    subtitle: (
    <>
      <div className="typing-container">
        <p className="typing-text subtitle">全臺公車動態輕鬆查</p>
      </div>
      <p>Your journey starts here.</p>
      <Button text="現在出發" link="/search-bus" />
    </>)
  };

  const content = (
    <div>
      <ServiceIntro/>
      <ScenarioBanner/>
    </div>
  );

  return (

    <GeneralTemplate 
      bannerProps={bannerProps} 
      content={content} 
    />
  );
}

export default Home;